import styled from 'styled-components';
import { Wrapper as _ModalWrapper } from 'Common/Components/ConfirmNavigationModal/styled';

const ModalWrapper = styled(_ModalWrapper)`
`;
ModalWrapper.displayName = 'ModalWrapper';

export default ModalWrapper;
